// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cfWs","label":"styles_label__3RLcx"};